import React from "react";
import { Radio } from "antd";

const { Button, Group } = Radio;

const RequestTypes = ({ onChangeTypeList, typesList, value }) => {
  return (
    <Group onChange={onChangeTypeList} defaultValue={value ? value : "all"}>
      {typesList &&
        typesList.map(item => {
          return (
            <Button
              key={item.type}
              value={item.type}
              disabled={item.count === 0}
            >
              {item.name}: {item.count}
            </Button>
          );
        })}
    </Group>
  );
};

export default RequestTypes;
